import script from "./ux-html.vue?vue&type=script&setup=true&lang=js"
export * from "./ux-html.vue?vue&type=script&setup=true&lang=js"

import "./ux-html.vue?vue&type=style&index=0&id=a5d3638e&lang=css"

const __exports__ = script;

export default __exports__